<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <div :class="b()">
    <div :class="b('header')">
      <button :class="b('header-back')" @click="handleBack">
        <span :class="b('header-icon')" v-html="displayedChevronIcon"></span>
      </button>

      <h2 :class="b('header-title')">
        {{ $t("Крипто реквизиты") }}
      </h2>
    </div>

    <div :class="b('form')">
      <div :class="b('form-field')">
        <h4 :class="b('form-label')">{{ $t("Название") }}*</h4>

        <UIInput view="light" v-model="requisitesCryptoRequest.name" />
      </div>

      <div :class="b('form-field')">
        <h4 :class="b('form-label')">{{ $t("Монета") }}*</h4>

        <UIInput view="light" v-model="requisitesCryptoRequest.coin" />
      </div>

      <div :class="b('form-field')">
        <h4 :class="b('form-label')">{{ $t("Сеть") }}*</h4>

        <UIInput view="light" v-model="requisitesCryptoRequest.network" />
      </div>

      <div :class="b('form-field')">
        <h4 :class="b('form-label')">{{ $t("Адрес") }}*</h4>

        <UIInput view="light" v-model="requisitesCryptoRequest.address" />
      </div>
    </div>

    <UIButton
      :class="b('confirm')"
      view="main"
      :disabled="isConfirmDisabled"
      @click="handleConfirm"
    >
      <span>{{ $t("Подтвердить") }}</span>
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M5 12h13m-5-5 5 5-5 5" />
      </svg>
    </UIButton>
  </div>
</template>
